


















import { Component, Mixins } from 'vue-property-decorator';
import BreadcrumbMixin from '@/mixins/breadcrumbs';
import { Breadcrumbs as BreadcrumbsLayout } from '@/components/layout';
import { Articlehtml as ArticlePage } from '@/components/parts/article';
import Messages from '@/components/parts/messages';
import { mapActions } from 'vuex';
import { namespace, State } from 'vuex-class';
import createStoreModule from './store';
import { Statuses, MunicipalityId } from './types';
import {
  ACTION_FETCH,
  STORE_MODULE_NAME,
  CHILD_TITLE,
  CERT_TITLE,
  ERROR_DEFAULT_TEXT,
  INFO_TEXT,
} from './const';

const Inquiry = namespace(STORE_MODULE_NAME);
const actions = mapActions(STORE_MODULE_NAME, [ACTION_FETCH]);
const fetch = actions[ACTION_FETCH];

@Component({
  components: {
    BreadcrumbsLayout,
    ArticlePage,
    Messages,
  },
  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,
})
export default class PagesInquiry extends Mixins(BreadcrumbMixin) {
  // Bindings
  @Inquiry.State rulesConfirm: string;
  @Inquiry.State rulesIssue: string;
  @Inquiry.State status: string;
  @State municipalities: Array<any>;

  // Readonly
  readonly childTitle: string = CHILD_TITLE;
  readonly certTitle: string = CERT_TITLE;
  readonly errorText: string = ERROR_DEFAULT_TEXT;
  readonly infoText: string = INFO_TEXT;

  get breadcrumbsExtended() {
    const { breadcrumbs, pageTitle } = this;
    return [...breadcrumbs, { text: pageTitle }];
  }

  get routeQuery(): string {
    return this.$route.query.data;
  }

  get isError(): boolean {
    return this.status === Statuses.ERROR;
  }

  get isRulesConfirm(): boolean {
    return this.routeQuery === 'rulesConfirm';
  }

  get pageTitle(): string {
    const { isRulesConfirm, childTitle, certTitle } = this;
    return isRulesConfirm ? childTitle : certTitle;
  }

  get pageText(): string {
    const { isRulesConfirm, rulesConfirm, rulesIssue } = this;
    return isRulesConfirm ? rulesConfirm : rulesIssue;
  }

  get municipalityName() {
    const { municipalities, $route, infoText } = this;
    const { municipality_id } = $route.query;
    if (!municipalities.length && !municipality_id) return '';
    const result = municipalities.find(
      ({ id }: MunicipalityId) => id === municipality_id,
    );
    const municipalityName = result ? result.name : '';
    return `${infoText} ${municipalityName}`;
  }

  // AsyncData
  async asyncData({ store, route }: any) {
    await fetch.call(
      { $store: store },
      {
        municipalityId: route.query.municipality_id,
      },
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/inquiry/Inquiry.vue